import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
  CreateJobDescriptionInput,
  UpdateJobDescriptionInput,
} from './job-description.interface';

const API_URI = `${environment.apiBaseUrl}/jobs`;

@Injectable({
  providedIn: 'root',
})
export class JobDescriptionSevice {
  http: HttpClient = inject(HttpClient);

  getJobDescriptions() {
    return this.http.get(API_URI + '/description');
  }

  createDesc(input: CreateJobDescriptionInput) {
    return this.http.post(API_URI + '/description', input);
  }
  getSingle(id: string) {
    return this.http.get(API_URI + `/description/${id}`);
  }
  updateDesc(input: UpdateJobDescriptionInput) {
    return this.http.put(API_URI + '/description', input);
  }

  deleteDesc(id: string) {
    return this.http.delete(API_URI + `/description/${id}`);
  }
}
